import {
  ID_CATEGORIA_SERVICIOS,
  ID_CATEGORIA_VEHICULOS,
  TIPO_PRODUCTO_PRODUCTOS,
  TIPO_PRODUCTO_SCRAP,
  TIPO_PRODUCTO_SERVICIOS,
  TIPO_PRODUCTO_VEHICULOS
} from './publicaciones.js'

export const CATEGORIA_FIJA_POR_TIPO = {
  [TIPO_PRODUCTO_SERVICIOS]: ID_CATEGORIA_SERVICIOS,
  [TIPO_PRODUCTO_VEHICULOS]: ID_CATEGORIA_VEHICULOS
}

export const CATEGORIAS_EXCLUIDAS_POR_TIPO = {
  [TIPO_PRODUCTO_PRODUCTOS]: [ID_CATEGORIA_SERVICIOS, ID_CATEGORIA_VEHICULOS],
  [TIPO_PRODUCTO_SCRAP]: [ID_CATEGORIA_SERVICIOS, ID_CATEGORIA_VEHICULOS]
}

export const TIPOS_SIN_ESTADO_PRODUCTO = [TIPO_PRODUCTO_SERVICIOS, TIPO_PRODUCTO_SCRAP]
export const TIPOS_SIN_MEDIOS_DE_ENVIO = [TIPO_PRODUCTO_SERVICIOS, TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_SIN_EAN = [TIPO_PRODUCTO_SERVICIOS, TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_SIN_PRECIO_MAYORISTA = [TIPO_PRODUCTO_SERVICIOS, TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_SIN_CONDICIONES_DE_VENTA = [TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_SIN_COMPRA = [TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_CON_CONTACTO_WHATSAPP = [TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_CON_ABONO_AL_PUBLICAR = [TIPO_PRODUCTO_VEHICULOS]
export const TIPOS_SIN_A_PEDIDO = [
  TIPO_PRODUCTO_SCRAP,
  TIPO_PRODUCTO_SERVICIOS,
  TIPO_PRODUCTO_VEHICULOS
]
export const TIPOS_SIN_PRESUPUESTO = [
  TIPO_PRODUCTO_PRODUCTOS,
  TIPO_PRODUCTO_SCRAP,
  TIPO_PRODUCTO_VEHICULOS
]

export const requiereEstadoProducto = (tipoProducto) =>
  !TIPOS_SIN_ESTADO_PRODUCTO.includes(tipoProducto)

/**
 * Funcion centralizada que devuelve las reglas para cada tipo de publicación.
 * @param {string|null} tipoProducto - Uno de los TIPO_PRODUCTO_*.
 * @returns {Object} Las reglas que aplican a ese tipo.
 */
export const obtenerReglasPorTipo = (tipoProducto) => ({
  verEstadoProducto: requiereEstadoProducto(tipoProducto),
  conAbonoAlPublicar: TIPOS_CON_ABONO_AL_PUBLICAR.includes(tipoProducto),
  categoriaFija: CATEGORIA_FIJA_POR_TIPO[tipoProducto] ?? null,
  categoriasExcluidas: CATEGORIAS_EXCLUIDAS_POR_TIPO[tipoProducto] ?? null,
  ocultarEan: TIPOS_SIN_EAN.includes(tipoProducto),
  ocultarPrecioMayorista: TIPOS_SIN_PRECIO_MAYORISTA.includes(tipoProducto),
  ocultarCondicionesDeVenta: TIPOS_SIN_CONDICIONES_DE_VENTA.includes(tipoProducto),
  ocultarMediosDeEnvio: TIPOS_SIN_MEDIOS_DE_ENVIO.includes(tipoProducto),
  permiteComprar: !TIPOS_SIN_COMPRA.includes(tipoProducto),
  contactoPorWhatsapp: TIPOS_CON_CONTACTO_WHATSAPP.includes(tipoProducto),
  ocultarAPedido: TIPOS_SIN_A_PEDIDO.includes(tipoProducto),
  ocultarPresupuesto: TIPOS_SIN_PRESUPUESTO.includes(tipoProducto)
})

export const obtenerCategoriaRaizDesdeRoot = (root) => {
  if (!root) {
    return null
  }

  try {
    const [raiz] = JSON.parse(root)
    return Number(raiz?.id) || null
  } catch {
    return null
  }
}

export const esPublicacionDeVehiculo = (publicacion) =>
  obtenerCategoriaRaizDesdeRoot(publicacion?.categoria?.root) === ID_CATEGORIA_VEHICULOS

/**
 *  Deduce el tipo de producto de una publicación ya creada, para condicionar
 * el renderizado de administrar publicación.
 * @param {Object} params
 * @param {string|null} [params.tipoProducto]
 * @param {boolean} [params.esScrap]
 * @param {number|null} [params.idCategoriaRaiz]
 * @returns {string|null} El tipo de producto, o null si no se puede deducir.
 */
export const deducirTipoProducto = ({ tipoProducto, esScrap, idCategoriaRaiz } = {}) => {
  if (tipoProducto) {
    return tipoProducto
  }

  if (esScrap) {
    return TIPO_PRODUCTO_SCRAP
  }

  if (idCategoriaRaiz === ID_CATEGORIA_SERVICIOS) {
    return TIPO_PRODUCTO_SERVICIOS
  }

  if (idCategoriaRaiz === ID_CATEGORIA_VEHICULOS) {
    return TIPO_PRODUCTO_VEHICULOS
  }

  return idCategoriaRaiz ? TIPO_PRODUCTO_PRODUCTOS : null
}

/**
 * Deduce el tipo de producto de una publicación del detalle público, donde el
 * único dato disponible es el árbol de categorías.
 * @param {Object} publicacion
 * @returns {string|null} El tipo de producto, o null si no se puede deducir.
 */
export const deducirTipoDesdeCategoria = (publicacion) =>
  deducirTipoProducto({
    esScrap: publicacion?.esScrap,
    idCategoriaRaiz: obtenerCategoriaRaizDesdeRoot(publicacion?.categoria?.root)
  })
